const inFlight = new Map();

/**
 * Concurrent GETs of the same URL and token share one request, so a tab that mounts twice (StrictMode) or reloads
 * while its first load is still running calls the API once.
 */
const sharedGet = (url, token, load) => {
  const key = `${token}\n${url}`;
  const pending = inFlight.get(key);
  if (pending) return pending;
  const promise = load().finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
};

export default sharedGet;
